import { render, staticRenderFns } from "./CandidateDashboard.vue?vue&type=template&id=6417b045&scoped=true&"
import script from "./CandidateDashboard.vue?vue&type=script&lang=ts&"
export * from "./CandidateDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateDashboard.vue?vue&type=style&index=0&id=6417b045&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6417b045",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow,VSkeletonLoader})
